import React from 'react';
import GameOptionButton from '../hidden-picture/game-option-button';

export default class WorksheetsControls extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  printAction() {
    window.print();
  }

  render() {
    return(
      <div className="worksheets__controls">
        <div className="hidden-picture__options">
          <div className="hidden-picture__reset-button"
            onClick={this.printAction}>
            Print
          </div>
          <div className="hidden-picture__options-heading">
            Subject
          </div>
          <div className="hidden-picture__options-panel">
            <GameOptionButton button="addition"
              current={this.props.sheetType} action={this.props.chooseType  } />
            <GameOptionButton button="subtraction"
              current={this.props.sheetType} action={this.props.chooseType} />
            <GameOptionButton button="multiplication"
              current={this.props.sheetType} action={this.props.chooseType} />
            <GameOptionButton button="division"
              current={this.props.sheetType} action={this.props.chooseType} />
          </div>
          <div className="hidden-picture__options-heading">
            Difficulty
          </div>
          <div className="hidden-picture__options-panel">
            <GameOptionButton button="1" label="Easy"
              current={this.props.sheetPlaces} action={this.props.choosePlaces} />
            <GameOptionButton button="2" label="Medium"
              current={this.props.sheetPlaces} action={this.props.choosePlaces} />
            <GameOptionButton button="3" label="Hard"
              current={this.props.sheetPlaces} action={this.props.choosePlaces} />
          </div>
        </div>
      </div>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/worksheets/worksheets-controls.js
 **/